import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Modal } from 'bootstrap';
import { Food } from 'src/app/interfaces/food';
import { User } from 'src/app/interfaces/user';
import { FoodService } from 'src/app/services/food.service';
import { StateService } from 'src/app/services/state.service';
import { StorageService } from 'src/app/services/storage.service';
import { ToastService } from 'src/app/services/toast.service';
import { FoodFormModalComponent } from '../food-form-modal/food-form-modal.component';

@Component({
  selector: 'app-food-list-modal',
  templateUrl: './food-list-modal.component.html',
  styleUrls: ['./food-list-modal.component.scss'],
})
export class FoodListModalComponent implements OnInit {
  @Output() changeEditing = new EventEmitter<any>();
  user?: User;
  foods?: Food[];

  constructor(
    private toastService: ToastService,
    private storageService: StorageService,
    private stateService: StateService,
    private foodService: FoodService
  ) {}

  ngOnInit(): void {
    this.user = this.storageService.get('staffUser', true);

    this.getAllFoods();
  }

  getAllFoods() {
    this.foodService.getAllFoods().subscribe({
      next: (response: any) => {
        this.foods = response;
        this.foods?.forEach((food: Food) => {
          food.totalFats = food.saturatedFats + food.unsaturatedFats;
        });
      },
    });
  }

  openFoodFormModal() {
    this.stateService.openModal.hide();

    const foodFormModal = new Modal('#foodFormModal');

    const foodFormModalHTMLElement = document.getElementById('foodFormModal');

    foodFormModalHTMLElement!.addEventListener('hidden.bs.modal', () => {
      this.getAllFoods();
    });

    foodFormModalHTMLElement!.addEventListener('shown.bs.modal', () => {});

    this.stateService.openModal = foodFormModal;

    foodFormModal.show();
  }

  deleteFood(food: Food, ev: Event) {
    ev.stopPropagation();

    if (window.confirm('¿Estás seguro que quieres eliminar esta comida?')) {
      this.foodService.deleteFood(food.id!).subscribe({
        next: () => {
          this.getAllFoods();
        },
      });
    }
  }

  selectFood(food: Food, ev: Event) {
    ev.stopPropagation();

    this.stateService.selectedFood = food;
    this.stateService.updateEdition(true);

    this.openFoodFormModal();
  }
}
